/** Simple email format check; matches backend zod .email() behavior. */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value.trim());
}

/** Max lengths aligned with API schemas (property, room, tenant). */
export const MAX_LENGTHS = {
  propertyName: 200,
  address: 500,
  city: 100,
  state: 100,
  pincode: 20,
  unitAlias: 100,
  unitNumber: 50,
  notes: 500,
} as const;
